<template>
  <cp-general-modal
    ref="systemAgreement"
    :title="getTitleName"
    :title-icon="`ion ion-${titleData.icon}`"
    :default-value="agreementData"
    @onOk="handleSubmit"
    @onInput="handleInModalChanges"
  >
    <cp-input
      name="name"
      label="Name"
      validate="required"
      :disabled="titleData.type === 'Edit'"
    />
    <cp-input
      name="title"
      label="Title"
      validate="required"
    />
    <cp-select
      name="type"
      label="Type"
      :options="typeOptions"
    />
    <div v-show="model.type === 'yes_no'">
      <cp-text-area
        name="yesText"
        label="Yes Agreement Text"
        :rows="5"
        :validate="model.type === 'yes_no' ? 'required' : ''"
      />
      <cp-text-area
        name="noText"
        label="No Agreement Text"
        :rows="5"
        :validate="model.type === 'yes_no' ? 'required' : ''"
      />
    </div>

    <cp-text-area
      name="text"
      label="Agreement Text"
      :rows="5"
      :validate="model.type === 'yes' ? 'required' : ''"
    />

    <div
      v-if="titleData.type === 'Edit'"
      class="row mt-2"
    >
      <div class="col text-muted">
        <label class="form-label">
          Created
        </label> <br>
        <span>
          {{ model.createdAt | dateFilter }}
        </span>
      </div>
      <div class="col text-muted">
        <label class="form-label">
          Updated
        </label>  <br>
        <span>
          {{ model.updatedAt | dateFilter }}
        </span>
      </div>
    </div>
  </cp-general-modal>
</template>

<script>
import CpGeneralModal from '~/components/common/modals-components/general-modal';
import { CpInput, CpSelect, CpTextArea } from '~/components/common/standalone-components/inputs';

export default {
  name: 'SystemAgreementsModal',
  components: {
    CpGeneralModal,
    CpInput,
    CpSelect,
    CpTextArea,
  },
  props: {
    titleData: {
      type: Object,
      default: () => {},
    },
    agreementData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {},
      typeOptions: ['yes', 'yes_no'],
    };
  },
  computed: {
    getTitleName() {
      return `${this.titleData.type} Agreement`;
    },
  },
  watch: {
    agreementData: {
      handler(val) {
        this.model = Object.assign({}, val);
      },
    },
  },
  methods: {
    handleSubmit(data) {
      const agreement = { ...data };
      Object.keys(agreement).forEach((field) => {
        if (agreement[field] === null) {
          delete agreement[field];
        }
      });
      const action = agreement.agreementId ? 'onSaveChanging' : 'onSaveNewAgreement';
      this.$emit(action, agreement);
    },
    handleInModalChanges({ type }) {
      this.model.type = type;
    },
  },
};
</script>
